import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ac4eade0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac4eade0')) {
      api.createRecord('ac4eade0', component.options)
    } else {
      api.reload('ac4eade0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ac4eade0", function () {
      api.rerender('ac4eade0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/GoodsInfoTab/index.vue"
export default component.exports